var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVCircleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#049F91"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0144 9.03497L16.0142 9.03513L10.5824 13.73L7.98557 11.4945C7.7378 11.2812 7.33363 11.2812 7.08586 11.4945C6.95053 11.611 6.875 11.7642 6.875 11.9231C6.875 12.0818 6.95048 12.2315 7.08817 12.3393L10.1192 14.9486C10.3678 15.1838 10.775 15.1838 11.0236 14.9486L16.9118 9.87975C17.0495 9.7719 17.125 9.62227 17.125 9.46357C17.125 9.30468 17.0495 9.15147 16.9141 9.03497C16.6664 8.82168 16.2622 8.82168 16.0144 9.03497Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVCircleFilled);
export default __webpack_public_path__ + "static/media/VCircleFilled.3b1ad1f2d4b044429403464840e92490.svg";
export { ForwardRef as ReactComponent };